import React from 'react';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
require('./ImageBox.scss');
class ImageBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onLoading: true
            ,src: 'about:blank'
        };
    }

    render() {
        return (<div className={classNames({ 'onload': !this.props.src }, 'image-box')} >
                    <div style={{ width: '100%',
                                  height: '100%',
                                  backgroundImage: 'url("' + this.props.src + '")',
                                  backgroundSize: '100% 100%'
                                }
                            } />
                    {!this.props.src ? <div className="image-null">？</div> :  null}
                </div>
        );
    }

}

export default ImageBox;



// WEBPACK FOOTER //
// ./src/components/TableColumns/ImageBox/ImageBox.js